import _ from 'lodash';
import React, { Component } from 'react';
import { when, _interceptReads } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import ReactHintFactory from 'react-hint';

import Label from './label';

const ReactHint = ReactHintFactory(React);

const getLocalKey = (key) => key.replace(/[^.]+\./, '');

@observer
export default class Field
extends Component {
	constructor (props) {
		super(props);

		this.state = {
			valid: true
		};

		this.addFormStoreListener();
	}

	addFormStoreListener () {
		const { formStore, fieldKey, item } = this.props;
		this.formStoreDisposer = when(
			() => formStore.shouldStoreFormData,
			() => {
				const key = getLocalKey(fieldKey);
				formStore.shouldStoreFormData = false;
				item[key] = this.getFieldValue();
			}
		);
	}

	componentWillUnmount () {
		this.formStoreDisposer();
	}

	render () {
		const {
			formStore,
			fieldKey,
			noFieldClass,
			floatLabel = false,
			defaultWidth = false
		} = this.props;

		const { conditions, fieldClass = ''  } = formStore.get(fieldKey);
		const labelCellClass = floatLabel ? 'auto small-order-2' : 'small-12';
		const inputCellClass = floatLabel ? 'small-1 small-order-1' : 'small-12';

		const fieldClassList = [
			noFieldClass ? '' : 'hfm-field', fieldClass, 'grid-x'
		];

		const className = _.compact(
			this.state.valid ?
				fieldClassList : [...fieldClassList, 'error']
		).join(' ');

		if (formStore.checkConditions(conditions)) {

			return (
				<div className={ className }>
					<ReactHint events={ { hover: false } } persist />

					<div className={ `cell ${labelCellClass}` }>
						<Label { ...this.props } />
					</div>

					<div id={fieldKey} className={ defaultWidth ? '' : `cell ${inputCellClass}` }>
						{ this.renderInput() }
					</div>
				</div>
			);
		}

		return null;
	}

	@autobind
	handleChange ({ target }) {
		const {
			fieldKey: key,
			dataId: id,
			formStore,
			store,
			item = {},
			handleChange,
			onChange,
			validate
		} = this.props;

		const {
			required = false
		} = formStore.get(key);

		if (_.isFunction(handleChange)) {

			/**
			 * handleChange is meant to circumvent the default change behavior
			 */
			return handleChange({ target });
		}

		const value = target.type === 'checkbox' ? target.checked : target.value;
		item[getLocalKey(key)] = value;

		const valid = _.isFunction(validate) ? validate(value, key) : formStore.validate(value, key);
		this.setState({ valid });

		if (_.isFunction(onChange)) {

			/**
			 * onChange is meant to react to the default change behavior
			 */
			return onChange(key, value);
		}
	}

	/**
	 * @deprecated
	 * Use getStoreValue(params) instead
	 */
	getValue (params) {
		return this.getStoreValue(params);
	}

	getStoreValue ({ fieldKey, dataId, valueKey, setFilter }) {
		const { item = null, store } = this.props;

		// There has to be a store or an item
		if (_.isEmpty(store) && _.isEmpty(item)) {

			return '';
		}

		const isReallyEmpty = (value) => _.isUndefined(value) || _.isNull(value);

		let value;

		if (_.isNull(item) !== true) {

			// If there is an item, get the value from it.
			// getLocalKey takes in "a.key.like.this" and turns it into "this"
			// getLocalKey takes in "a.key.like.this" and turns it into "this"
			value = item[getLocalKey(fieldKey)];
		} else if (_.isEmpty(dataId)) {

			// @deprecated
			value = store.get(fieldKey);
		} else {

			// If a dataId is passed it, we can look it up in the store
			const key = getLocalKey(fieldKey);
			value = store.items[store.getItemIndex({ id: dataId })][key];
		}

		if (valueKey && isReallyEmpty(value)) {

			// @deprecated
			value = store.get(valueKey);
		}

		if (_.isFunction(setFilter)) {

			// This allows for filtering the value before it is set on the field
			value = setFilter(value);
		}

		return value;
	}

	getFieldValue () {
		return '';
	}
}
